import { HousekeepingViewPermissions } from '@hkm/components/Housekeeping/shared/config/housekeepingViewPermissionsConfig';
import { Permission } from '@hkm/shared/permissions/enum/Permission';
import { PermissionConjunction } from '@hkm/shared/permissions/enum/PermissionConjunction';
import { PermissionsConfig } from '@hkm/shared/permissions/types/permissionsConfig';

export const MaintenancePermissions = [
  ...HousekeepingViewPermissions,
  Permission.HousekeepingViewAndManageMaintenance
] as const;

export const MaintenanceViewPermissionsConfig: PermissionsConfig = [
  MaintenancePermissions,
  PermissionConjunction.All
];



// WEBPACK FOOTER //
// ./src/components/Maintenance/config/maintenanceViewPermissionsConfig.ts